import { Component, Input, Output, HostListener, forwardRef, EventEmitter, ViewChild, Renderer2, ChangeDetectorRef, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/forms';

var _c0 = ["container"];
var _c1 = ["on"];
var _c2 = ["label"];
var _c3 = ["off"];
var callback = function () {
};
/** @type {?} */
var CUSTOM_INPUT = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return JwBootstrapSwitchNg2Component; }),
    multi: true
};
var JwBootstrapSwitchNg2Component = /** @class */ (function () {
    function JwBootstrapSwitchNg2Component(cd, render) {
        this.cd = cd;
        this.render = render;
        // Defining Default Options for Switch
        this.handleWidth = 0;
        this.labelWidth = 0;
        this.labelText = '';
        this.inverse = false;
        this.baseClass = 'bootstrap-switch';
        this.onText = 'ON';
        this.offText = 'OFF';
        this.disabled = false;
        this.readonly = false;
        this._focused = false;
        this._size = 'normal';
        this._animate = true;
        this._innerAnimate = true;
        this._indeterminate = false;
        this._onColor = 'primary';
        this._offColor = 'default';
        this._wrapperClass = 'wrapper';
        this._innerState = false;
        this._innerHandleWidth = 'auto';
        this._innerLabelWidth = 'auto';
        this._dragStart = null;
        this._dragEnd = null;
        this._onTouchedCallback = callback;
        this._onChangeCallback = callback;
        this.changeState = new EventEmitter();
    }
    /**
     * @private
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.$on = /**
     * @private
     * @return {?}
     */
    function () {
        return this.on.nativeElement;
    };
    /**
     * @private
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.$off = /**
     * @private
     * @return {?}
     */
    function () {
        return this.off.nativeElement;
    };
    /**
     * @private
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.$label = /**
     * @private
     * @return {?}
     */
    function () {
        return this.label.nativeElement;
    };
    /**
     * @private
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.$container = /**
     * @private
     * @return {?}
     */
    function () {
        return this.container.nativeElement;
    };
    /**
     * @description:  Function to set the Classes for the Wrapper Div
     * @returns string
     */
    /**
     * \@description: Function to set the Classes for the Wrapper Div
     * @return {?} string
     */
    JwBootstrapSwitchNg2Component.prototype.getWrapperClasses = /**
     * \@description: Function to set the Classes for the Wrapper Div
     * @return {?} string
     */
    function () {
        /** @type {?} */
        var output = this.baseClass + ' ' + this.baseClass + '-' + this._wrapperClass;
        if (this._focused) {
            output += ' ' + this.baseClass + '-focused';
        }
        if (this.readonly) {
            output += ' ' + this.baseClass + '-readonly';
        }
        if (this._size != null) {
            output += ' ' + this.baseClass + '-' + this._size;
        }
        if (this._innerState) {
            output += ' ' + this.baseClass + '-on';
        }
        else {
            output += ' ' + this.baseClass + '-off';
        }
        if (this._animate) {
            output += ' ' + this.baseClass + '-animate';
        }
        if (this.disabled) {
            output += ' ' + this.baseClass + '-disabled';
        }
        if (this._indeterminate || this._innerState === null || typeof this._innerState === 'undefined') {
            output += ' ' + this.baseClass + '-indeterminate';
        }
        if (this.inverse) {
            output += ' ' + this.baseClass + '-inverse';
        }
        return output;
    };
    /**
     * @description Function to set the css classes for #on
     * @returns string
     */
    /**
     * \@description Function to set the css classes for #on
     * @return {?} string
     */
    JwBootstrapSwitchNg2Component.prototype.getOnClasses = /**
     * \@description Function to set the css classes for #on
     * @return {?} string
     */
    function () {
        /** @type {?} */
        var output = this.baseClass + '-handle-on';
        if (this._onColor) {
            output += ' ' + this.baseClass + '-' + this._onColor;
        }
        return output;
    };
    /**
     * @description Function to set the css classes for #off
     * @returns string
     */
    /**
     * \@description Function to set the css classes for #off
     * @return {?} string
     */
    JwBootstrapSwitchNg2Component.prototype.getOffClasses = /**
     * \@description Function to set the css classes for #off
     * @return {?} string
     */
    function () {
        /** @type {?} */
        var output = this.baseClass + '-handle-off';
        if (this._offColor) {
            output += ' ' + this.baseClass + '-' + this._offColor;
        }
        return output;
    };
    /**
     * @description  Function set the marging of the #label when change the state
     * @returns string
     */
    /**
     * \@description Function set the marging of the #label when change the state
     * @return {?} string
     */
    JwBootstrapSwitchNg2Component.prototype.getLabelMarginLeft = /**
     * \@description Function set the marging of the #label when change the state
     * @return {?} string
     */
    function () {
        /** @type {?} */
        var width = (this.inverse) ? -this.handleWidth : 0;
        if (this._indeterminate || this._innerState === null || typeof this._innerState === 'undefined') {
            width = -(this.handleWidth / 2);
        }
        else if (this._dragEnd) {
            width = this._dragEnd;
        }
        else if (!this._innerState) {
            if (!this.inverse) {
                width = -this.handleWidth;
            }
            else {
                width = 0;
            }
        }
        return width + 'px';
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes['setLabelText'] ||
            changes['setOnText'] ||
            changes['setHandleWidth'] ||
            changes['setLabelWidth'] ||
            changes['setOffText'] ||
            changes['setSize']) {
            this.calculateWith(true);
        }
    };
    /**
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.calculateWith();
    };
    /**
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.onClick = /**
     * @return {?}
     */
    function () {
        if (!this.disabled && !this.readonly && !this._dragEnd) {
            this.setStateValue(!this._innerState);
        }
        else if (this._dragEnd) {
            this._dragEnd = null;
        }
    };
    /**
     * @param {?} e
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.onKeyDown = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (!e.which || this.disabled || this.readonly) {
            return;
        }
        switch (e.which) {
            case 37:
                e.preventDefault();
                e.stopImmediatePropagation();
                this.setStateValue(false);
                break;
            case 39:
                e.preventDefault();
                e.stopImmediatePropagation();
                this.setStateValue(true);
                break;
        }
    };
    /**
     * @private
     * @param {?} e
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.onDragStart = /**
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (e.target === this.$label()) {
            if (this._dragStart || this.disabled || this.readonly) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            this._dragStart = (e.pageX || e.touches[0].pageX) - parseInt(this.$container().style.marginLeft, 10);
            if (this._animate) {
                this._animate = !this._animate;
            }
        }
    };
    /**
     * @private
     * @param {?} e
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.onDragMove = /**
     * @private
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (this._dragStart) {
            e.preventDefault();
            /** @type {?} */
            var difference = (e.pageX || e.touches[0].pageX) - this._dragStart;
            if (difference < -Number(this.handleWidth) || difference > 0) {
                return;
            }
            this._dragEnd = difference;
        }
    };
    /**
     * @private
     * @param {?} e
     * @param {?=} removeDragEnd
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.onDragEnd = /**
     * @private
     * @param {?} e
     * @param {?=} removeDragEnd
     * @return {?}
     */
    function (e, removeDragEnd) {
        if (removeDragEnd === void 0) { removeDragEnd = false; }
        if (this._dragStart) {
            e.preventDefault();
            e.stopPropagation();
            if (this._dragEnd) {
                /** @type {?} */
                var state = this._dragEnd > -(Number(this.handleWidth) / 2);
                this.setStateValue((this.inverse) ? !state : state);
            }
            this._dragStart = null;
            if (removeDragEnd) {
                this._dragEnd = null;
            }
            if (this._innerAnimate) {
                this._animate = true;
            }
        }
    };
    /**
     * @param {?} e
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.onTouchStart = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.onDragStart(e);
    };
    /**
     * @param {?} e
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.onMouseDown = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.onDragStart(e);
    };
    /**
     * @param {?} e
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.onTouchMove = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.onDragMove(e);
    };
    /**
     * @param {?} e
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.onMouseMove = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.onDragMove(e);
    };
    /**
     * @param {?} e
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.onMouseUp = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.onDragEnd(e);
    };
    /**
     * @param {?} e
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.onTouchEnd = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.onDragEnd(e, true);
    };
    /**
     * @param {?} e
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.onMouseLeave = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.onDragEnd(e, true);
    };
    /**
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.onFocus = /**
     * @return {?}
     */
    function () {
        this._focused = true;
    };
    /**
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.onBlur = /**
     * @return {?}
     */
    function () {
        this._focused = false;
        this._onTouchedCallback();
    };
    /**
     * @description Function to make recalculate the size of the elements when options change
     * @param disableAnimation
     */
    /**
     * \@description Function to make recalculate the size of the elements when options change
     * @private
     * @param {?=} disableAnimation
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.calculateWith = /**
     * \@description Function to make recalculate the size of the elements when options change
     * @private
     * @param {?=} disableAnimation
     * @return {?}
     */
    function (disableAnimation) {
        var _this = this;
        if (disableAnimation === void 0) { disableAnimation = false; }
        if (disableAnimation && this._innerAnimate) {
            this._animate = false;
        }
        setTimeout(function () {
            _this.render.setStyle(_this.$on(), 'width', 'auto');
            _this.render.setStyle(_this.$off(), 'width', 'auto');
            _this.render.setStyle(_this.$label(), 'width', 'auto');
            /** @type {?} */
            var width = (_this._innerHandleWidth === 'auto')
                ? Math.max(_this.$on().offsetWidth, _this.$off().offsetWidth)
                : _this._innerHandleWidth;
            if (_this.$label().offsetWidth < width) {
                if (_this._innerLabelWidth === 'auto') {
                    _this.labelWidth = Number(width);
                }
                else {
                    _this.labelWidth = Number(_this._innerLabelWidth);
                }
            }
            else {
                if (_this._innerLabelWidth === 'auto') {
                    _this.labelWidth = _this.$label().offsetWidth;
                }
                else {
                    _this.labelWidth = Number(_this._innerLabelWidth);
                }
            }
            _this.handleWidth = Number(width);
            _this.render.setStyle(_this.$label(), 'width', _this.labelWidth + 'px');
            _this.render.setStyle(_this.$on(), 'width', _this.handleWidth + 'px');
            _this.render.setStyle(_this.$off(), 'width', _this.handleWidth + 'px');
            setTimeout(function () {
                if (disableAnimation && _this._innerAnimate) {
                    _this._animate = true;
                }
            });
            _this.cd.markForCheck();
        });
    };
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setBaseClass", {
        // Functions to set inputs and the private variables of the Switch
        set: 
        // Functions to set inputs and the private variables of the Switch
        /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.baseClass = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setWrapperClass", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._wrapperClass = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setOffText", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.offText = (value) ? value : 'OFF';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setLabelText", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.labelText = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setOnText", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.onText = (value) ? value : 'ON';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setSize", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                this._size = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setAnimate", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._animate = value;
            this._innerAnimate = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setOnColor", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                this._onColor = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setOffColor", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value) {
                this._offColor = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setDisabled", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.disabled = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setReadOnly", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.readonly = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setIndeterminate", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._indeterminate = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setInverse", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.inverse = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setHandleWidth", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._innerHandleWidth = (typeof (value) !== 'undefined') ? value : 'auto';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "setLabelWidth", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._innerLabelWidth = (typeof (value) !== 'undefined') ? value : 'auto';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JwBootstrapSwitchNg2Component.prototype, "value", {
        get: /**
         * @return {?}
         */
        function () {
            return this._innerState;
        },
        set: /**
         * @param {?} v
         * @return {?}
         */
        function (v) {
            if (v === null || typeof v === 'undefined') {
                this._indeterminate = true;
            }
            this.setStateValue(v);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @private
     * @param {?} v
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.setStateValue = /**
     * @private
     * @param {?} v
     * @return {?}
     */
    function (v) {
        if (v !== this._innerState) {
            this._onChangeCallback(v);
            this.changeState.emit({
                previousValue: this._innerState,
                currentValue: v
            });
            this._innerState = v;
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (value !== this._innerState) {
            this._innerState = value;
            this.cd.markForCheck();
        }
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this.disabled = isDisabled;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this._onChangeCallback = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    JwBootstrapSwitchNg2Component.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this._onTouchedCallback = fn;
    };
    /** @nocollapse */
    JwBootstrapSwitchNg2Component.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: Renderer2 }
    ]; };
    JwBootstrapSwitchNg2Component.propDecorators = {
        changeState: [{ type: Output }],
        container: [{ type: ViewChild, args: ['container',] }],
        on: [{ type: ViewChild, args: ['on',] }],
        label: [{ type: ViewChild, args: ['label',] }],
        off: [{ type: ViewChild, args: ['off',] }],
        onClick: [{ type: HostListener, args: ['click',] }],
        onKeyDown: [{ type: HostListener, args: ['keydown', ['$event'],] }],
        onTouchStart: [{ type: HostListener, args: ['touchstart', ['$event'],] }],
        onMouseDown: [{ type: HostListener, args: ['mousedown', ['$event'],] }],
        onTouchMove: [{ type: HostListener, args: ['touchmove', ['$event'],] }],
        onMouseMove: [{ type: HostListener, args: ['mousemove', ['$event'],] }],
        onMouseUp: [{ type: HostListener, args: ['mouseup', ['$event'],] }],
        onTouchEnd: [{ type: HostListener, args: ['touchend', ['$event'],] }],
        onMouseLeave: [{ type: HostListener, args: ['mouseleave', ['$event'],] }],
        setBaseClass: [{ type: Input, args: ['switch-base-class',] }],
        setWrapperClass: [{ type: Input, args: ['switch-wrapper-class',] }],
        setOffText: [{ type: Input, args: ['switch-off-text',] }],
        setLabelText: [{ type: Input, args: ['switch-label-text',] }],
        setOnText: [{ type: Input, args: ['switch-on-text',] }],
        setSize: [{ type: Input, args: ['switch-size',] }],
        setAnimate: [{ type: Input, args: ['switch-animate',] }],
        setOnColor: [{ type: Input, args: ['switch-on-color',] }],
        setOffColor: [{ type: Input, args: ['switch-off-color',] }],
        setDisabled: [{ type: Input, args: ['switch-disabled',] }],
        setReadOnly: [{ type: Input, args: ['switch-readonly',] }],
        setIndeterminate: [{ type: Input, args: ['switch-indeterminate',] }],
        setInverse: [{ type: Input, args: ['switch-inverse',] }],
        setHandleWidth: [{ type: Input, args: ['switch-handle-width',] }],
        setLabelWidth: [{ type: Input, args: ['switch-label-width',] }]
    };
JwBootstrapSwitchNg2Component.ɵfac = function JwBootstrapSwitchNg2Component_Factory(t) { return new (t || JwBootstrapSwitchNg2Component)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
JwBootstrapSwitchNg2Component.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: JwBootstrapSwitchNg2Component, selectors: [["bSwitch"]], viewQuery: function JwBootstrapSwitchNg2Component_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
        ɵngcc0.ɵɵviewQuery(_c1, true);
        ɵngcc0.ɵɵviewQuery(_c2, true);
        ɵngcc0.ɵɵviewQuery(_c3, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.container = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.on = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.label = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.off = _t.first);
    } }, hostBindings: function JwBootstrapSwitchNg2Component_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function JwBootstrapSwitchNg2Component_click_HostBindingHandler() { return ctx.onClick(); })("keydown", function JwBootstrapSwitchNg2Component_keydown_HostBindingHandler($event) { return ctx.onKeyDown($event); })("touchstart", function JwBootstrapSwitchNg2Component_touchstart_HostBindingHandler($event) { return ctx.onTouchStart($event); })("mousedown", function JwBootstrapSwitchNg2Component_mousedown_HostBindingHandler($event) { return ctx.onMouseDown($event); })("touchmove", function JwBootstrapSwitchNg2Component_touchmove_HostBindingHandler($event) { return ctx.onTouchMove($event); })("mousemove", function JwBootstrapSwitchNg2Component_mousemove_HostBindingHandler($event) { return ctx.onMouseMove($event); })("mouseup", function JwBootstrapSwitchNg2Component_mouseup_HostBindingHandler($event) { return ctx.onMouseUp($event); })("touchend", function JwBootstrapSwitchNg2Component_touchend_HostBindingHandler($event) { return ctx.onTouchEnd($event); })("mouseleave", function JwBootstrapSwitchNg2Component_mouseleave_HostBindingHandler($event) { return ctx.onMouseLeave($event); });
    } }, inputs: { setBaseClass: ["switch-base-class", "setBaseClass"], setWrapperClass: ["switch-wrapper-class", "setWrapperClass"], setOffText: ["switch-off-text", "setOffText"], setLabelText: ["switch-label-text", "setLabelText"], setOnText: ["switch-on-text", "setOnText"], setSize: ["switch-size", "setSize"], setAnimate: ["switch-animate", "setAnimate"], setOnColor: ["switch-on-color", "setOnColor"], setOffColor: ["switch-off-color", "setOffColor"], setDisabled: ["switch-disabled", "setDisabled"], setReadOnly: ["switch-readonly", "setReadOnly"], setIndeterminate: ["switch-indeterminate", "setIndeterminate"], setInverse: ["switch-inverse", "setInverse"], setHandleWidth: ["switch-handle-width", "setHandleWidth"], setLabelWidth: ["switch-label-width", "setLabelWidth"] }, outputs: { changeState: "changeState" }, features: [ɵngcc0.ɵɵProvidersFeature([CUSTOM_INPUT]), ɵngcc0.ɵɵNgOnChangesFeature()], decls: 11, vars: 17, consts: [[3, "ngClass"], ["container", ""], [3, "innerHTML", "ngClass"], ["on", ""], ["label", ""], ["off", ""], ["type", "checkbox", 3, "ngModel", "readonly", "disabled", "ngModelChange", "focus", "blur"]], template: function JwBootstrapSwitchNg2Component_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 0, 1);
        ɵngcc0.ɵɵelement(3, "span", 2, 3);
        ɵngcc0.ɵɵelementStart(5, "span", 0, 4);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(8, "span", 2, 5);
        ɵngcc0.ɵɵelementStart(10, "input", 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function JwBootstrapSwitchNg2Component_Template_input_ngModelChange_10_listener($event) { return ctx.value = $event; })("focus", function JwBootstrapSwitchNg2Component_Template_input_focus_10_listener() { return ctx.onFocus(); })("blur", function JwBootstrapSwitchNg2Component_Template_input_blur_10_listener() { return ctx.onBlur(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("width", ctx.handleWidth + ctx.labelWidth + "px");
        ɵngcc0.ɵɵproperty("ngClass", ctx.getWrapperClasses());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("width", ctx.handleWidth * 2 + ctx.labelWidth + "px")("margin-left", ctx.getLabelMarginLeft());
        ɵngcc0.ɵɵproperty("ngClass", ctx.baseClass + "-container");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.inverse ? ctx.offText : ctx.onText, ɵngcc0.ɵɵsanitizeHtml)("ngClass", ctx.inverse ? ctx.getOffClasses() : ctx.getOnClasses());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.baseClass + "-label");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1("\u00A0", ctx.labelText, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.inverse ? ctx.onText : ctx.offText, ɵngcc0.ɵɵsanitizeHtml)("ngClass", ctx.inverse ? ctx.getOnClasses() : ctx.getOffClasses());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.value)("readonly", ctx.readonly)("disabled", ctx.disabled);
    } }, directives: [ɵngcc1.NgClass, ɵngcc2.CheckboxControlValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgModel], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(JwBootstrapSwitchNg2Component, [{
        type: Component,
        args: [{
                selector: 'bSwitch',
                providers: [CUSTOM_INPUT],
                template: "\n      <div [ngClass]=\"getWrapperClasses()\" [style.width]=\"(handleWidth  + labelWidth ) +'px'\">\n          <div #container [ngClass]=\"baseClass + '-container'\"\n               [style.width]=\"((handleWidth * 2) + labelWidth) +'px'\"\n               [style.margin-left]=\"getLabelMarginLeft()\"><!--\n              --><span #on [innerHTML]=\"(inverse) ? offText : onText\"\n                [ngClass]=\"(inverse) ? getOffClasses() : getOnClasses()\"></span><!--\n              --><span #label [ngClass]=\"baseClass + '-label'\">&nbsp;{{ labelText }}</span><!--\n              --><span #off [innerHTML]=\"(inverse) ? onText : offText\"\n                [ngClass]=\"(inverse) ? getOnClasses() : getOffClasses()\"></span><!--\n              --><input type=\"checkbox\" [(ngModel)]=\"value\" [readonly]=\"readonly\" [disabled]=\"disabled\"\n                     (focus)=\"onFocus()\" (blur)=\"onBlur()\">\n          </div>\n      </div>"
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.Renderer2 }]; }, { changeState: [{
            type: Output
        }], onClick: [{
            type: HostListener,
            args: ['click']
        }], onKeyDown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], onTouchStart: [{
            type: HostListener,
            args: ['touchstart', ['$event']]
        }], onMouseDown: [{
            type: HostListener,
            args: ['mousedown', ['$event']]
        }], onTouchMove: [{
            type: HostListener,
            args: ['touchmove', ['$event']]
        }], onMouseMove: [{
            type: HostListener,
            args: ['mousemove', ['$event']]
        }], onMouseUp: [{
            type: HostListener,
            args: ['mouseup', ['$event']]
        }], onTouchEnd: [{
            type: HostListener,
            args: ['touchend', ['$event']]
        }], onMouseLeave: [{
            type: HostListener,
            args: ['mouseleave', ['$event']]
        }], setBaseClass: [{
            type: Input,
            args: ['switch-base-class']
        }], setWrapperClass: [{
            type: Input,
            args: ['switch-wrapper-class']
        }], setOffText: [{
            type: Input,
            args: ['switch-off-text']
        }], setLabelText: [{
            type: Input,
            args: ['switch-label-text']
        }], setOnText: [{
            type: Input,
            args: ['switch-on-text']
        }], setSize: [{
            type: Input,
            args: ['switch-size']
        }], setAnimate: [{
            type: Input,
            args: ['switch-animate']
        }], setOnColor: [{
            type: Input,
            args: ['switch-on-color']
        }], setOffColor: [{
            type: Input,
            args: ['switch-off-color']
        }], setDisabled: [{
            type: Input,
            args: ['switch-disabled']
        }], setReadOnly: [{
            type: Input,
            args: ['switch-readonly']
        }], setIndeterminate: [{
            type: Input,
            args: ['switch-indeterminate']
        }], setInverse: [{
            type: Input,
            args: ['switch-inverse']
        }], setHandleWidth: [{
            type: Input,
            args: ['switch-handle-width']
        }], setLabelWidth: [{
            type: Input,
            args: ['switch-label-width']
        }], container: [{
            type: ViewChild,
            args: ['container']
        }], on: [{
            type: ViewChild,
            args: ['on']
        }], label: [{
            type: ViewChild,
            args: ['label']
        }], off: [{
            type: ViewChild,
            args: ['off']
        }] }); })();
    return JwBootstrapSwitchNg2Component;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var JwBootstrapSwitchNg2Module = /** @class */ (function () {
    function JwBootstrapSwitchNg2Module() {
    }
JwBootstrapSwitchNg2Module.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: JwBootstrapSwitchNg2Module });
JwBootstrapSwitchNg2Module.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function JwBootstrapSwitchNg2Module_Factory(t) { return new (t || JwBootstrapSwitchNg2Module)(); }, imports: [[
            CommonModule,
            FormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(JwBootstrapSwitchNg2Module, { declarations: function () { return [JwBootstrapSwitchNg2Component]; }, imports: function () { return [CommonModule,
        FormsModule]; }, exports: function () { return [JwBootstrapSwitchNg2Component]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(JwBootstrapSwitchNg2Module, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule
                ],
                declarations: [JwBootstrapSwitchNg2Component],
                exports: [JwBootstrapSwitchNg2Component]
            }]
    }], function () { return []; }, null); })();
    return JwBootstrapSwitchNg2Module;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { JwBootstrapSwitchNg2Component, JwBootstrapSwitchNg2Module };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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